import { Sparkle } from "lucide-react";

const SETS = {
  lg: [[0, 14, 14, 0], [100, 24, 12, 0.9], [97, 100, 14, 1.6], [2, 90, 10, 2.3], [62, 0, 10, 1.2], [30, 100, 9, 0.5]],
  sm: [[0, 22, 9, 0], [100, 30, 8, 1.1], [90, 100, 9, 0.6]],
};

export function Glitter({ size = "lg" }) {
  return (
    <span className="sp-glitter" aria-hidden data-testid="supporter-glitter">
      {SETS[size].map(([x, y, s, d], i) => (
        <Sparkle key={i} className={`absolute vip-twinkle ${i % 2 ? "text-amber-400" : "text-pink-500"}`} fill="currentColor" strokeWidth={0}
          style={{ left: `${x}%`, top: `${y}%`, width: s, height: s, marginLeft: -s / 2, marginTop: -s / 2, animationDelay: `${d}s` }} />
      ))}
    </span>
  );
}
